<template>
  <div style="position: relative;">
    <v-data-table :headers="headers" :items="list" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="items" slot-scope="props">
        <tr @click.stop="open_edit(props.item.id)">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.inserted_at | format("%d.%m.%Y %H:%M:%S") }}</td>
          <td>{{ props.item.updated_at | format("%d.%m.%Y %H:%M:%S") }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add"><v-icon>add</v-icon></v-btn>

    <v-toolbar :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; width: 300px;">
      <v-text-field color="deep-orange" v-model="search_text" ref="search_field" prepend-icon="search" hide-details single-line></v-text-field>
    </v-toolbar>

  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
export default {
  filters: datelib,
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Created at', value: 'inserted_at', align: 'left' },
        { text: 'Updated at', value: 'updated_at', align: 'left' }
      ],
      pagination: {
        sortBy: 'name',
        descending: true,
        rowsPerPage: 25
      },
      search_text: ""
    }
  },
  computed: {
    list () {
      var ret = Object.values(this.$store.state.running_orders);
      var search = (this.search_text || "").toLowerCase();
      if (search.length > 0) {
        ret = _.filter(ret, function(running_order) {
          ret = false;
          if (running_order.name.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }
      return ret;
    }
  },
  mounted () {
    this.$refs.search_field.focus();
  },
  methods: {
    open_add () {
      this.$router.push("/settings/running_orders/new")
    },
    open_edit (id) {
      this.$router.push("/settings/running_orders/edit/"+id)
    }
  }
}
</script>
